import { useEffect } from "react";
import useCountDown from "react-countdown-hook";
import { mdiAlarm } from "@mdi/js";
import Icon from "@mdi/react";
import { convertMsToRemainingTime } from "helpers/convertFormData";

interface ITimeLeftToBidProps {
  closeTime: number;
}

export default function TimeLeftToBid({ closeTime }: Readonly<ITimeLeftToBidProps>) {
  const [timeLeft, { start: startBidTimer }] = useCountDown(closeTime, 1000);

  useEffect(() => {
    if (closeTime > 0) {
      startBidTimer(closeTime);
    }
  }, [closeTime]);
  return (
    <>
      {closeTime < 0 ? (
        <span className="text-base text-error">Bidding Has Ended</span>
      ) : (
        <>
          <div className="flex items-center gap-2 font-normal text-error">
            <Icon path={mdiAlarm} className="m-auto text-error/f2" />
            <span>Time left to Bid :</span>
          </div>

          <span className="pr-1 text-error/ab">{convertMsToRemainingTime(timeLeft)}</span>
        </>
      )}
    </>
  );
}
